<template>
  <div id="import_etk_list">
     <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <div class="page-name">
                <div class="page-title"> Indirect Labor Code</div>
                <router-link type="submit" v-if="canAddEtk" class="btn btn-primary pull-right" v-bind:to="'/etk/form'" >
                    <i class="fp-add"></i> Add
                </router-link>
            </div>
            <template v-if="cantAccessPage === true">
                <div class="container-fluid">
                    <div class="admin-page-content indirect-labor-code">
                        <data-table-filter-config :moduleName="'etklist'" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="data-table border-top-table-fl">
                                <custom-pagination
                                            :page-changed="onPageChange"
                                            :per-page-changed="onPerPageChange" :moduleName="'etklist'" :position="'top'">

                                </custom-pagination>

                                <vue-good-table
                                            ref="listEtkTable"
                                            mode="remote"
                                            title="Indirect Labor Code"
                                            :columns="userColumns"
                                            :rows="rows"
                                            @on-page-change="onPageChange"
                                            @on-selected-rows-change="selectionChanged"
                                            @on-column-filter="onColumnFilter"
                                            @on-per-page-change="onPerPageChange"
                                            @on-sort-change="onSortChange"
                                            :totalRows="totalRecords"
                                            :pagination-options="{
                                                enabled: false,
                                                position: 'both',
                                                perPage: perPage,
                                                perPageDropdown:dropDownPerPage,
                                                dropdownAllowAll: false,
                                            }"
                                            :search-options="{
                                            enabled: false,
                                            }">
                                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                                <div :key="key">
                                                    <div v-if="props.column.field == 'action'">
                                                        <template v-if="canUpdateEtk">
                                                            <router-link title="Edit Etk Code" class="fp-edit" v-bind:to="{name: 'EtkListEdit',params:{id:props.row.id}}"></router-link>
                                                        </template>
                                                    </div>
                                                    <div v-else>
                                                        {{props.formattedRow[props.column.field]}}
                                                    </div>
                                                </div>
                                            </template>
                                </vue-good-table>
                                <custom-pagination
                                            :page-changed="onPageChange"
                                            :per-page-changed="onPerPageChange">
                                    </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
               <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
         <app-footer></app-footer>
      </div>
  </div>
</template>
<script>
import Vue from "vue";
import EventBus from ".././event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

var self;

export default {
    name: "ETKList",
        mixins:[commonMixins,dataTableMixins],
        data() {
            return {
              permissions: [],
            cantAccessPage: "",
            canUpdateEtk:false,
            canAddEtk:false,
            userColumns:[],

                columns: [
                  {
                       label: 'Actions',
                        field: 'action',
                        sortable:false,
                        hidden:false,
                    },
                  {
                        label: 'Code',
                        field: 'code',
                        filterable: true,
                        fpFieldType:"text",
                        hidden:false,
                        filterOptions: {
                              enabled: false, // enable filter for this column
                              placeholder: "Code", // placeholder for filter input
                              filterValue: '', // initial populated value for this filter
                              trigger: "enter" //only trigger on enter not on keyup
                          }
                    },

                   {
                        label: 'Description',
                        field: 'description',
                        filterable: true,
                        fpFieldType:"text",
                        hidden:false,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Description", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Type',
                        field: 'type',
                        filterable: true,
                        fpFieldType:"option",
                        hidden:false,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Description", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: ['Paid','Unpaid'],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },

                ],
                rows: [],
                totalRecords: 0,
            loading:false,


            }
         },
         watch:{
            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_indirect_code') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_indirect_code') {
                            self.canAddEtk = true;
                            self.canUpdateEtk = true;
                        }
                    }
                }

            }
        },
          mounted: function() {
            var self = this;
            self.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listEtkTable.unselectAllInternal();
            },
           selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                   // list_flag: list_flag,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/get-etklist",
                    type: "POST",
                    crossDomain: true,
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                         console.log(data.content);
                        if (data.message == "success") {
                          console.log(data.content.row);
                          self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            // if(list_flag != 'export') {
                            //     self.rows = data.content.row;
                            //     self.totalRecords = data.content.totalRecords;
                            //     self.filteredFlag = false;
                            // } else {

                            //     if (data.code == 201) {
                            //         alert(data.message);
                            //     }
                            //     else{
                            //         self.excel = data.content.web;
                            //         // var filename = data.content.filename;
                            //         var save = document.createElement("a");
                            //         save.href = self.excel;
                            //         // save.setAttribute('download', 'Reservation');
                            //         save.download = self.excel;
                            //         save.target = "_blank";
                            //         document.body.appendChild(save);
                            //         save.click();
                            //         document.body.removeChild(save);
                            //     }

                            // }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        // if(list_flag != 'export') {
                        //     self.generateStatusCodeMessage(jqXHR, false, 'transport-req-delete')
                        // }else{
                        //     self.generateStatusCodeMessage(jqXHR, false, 'transport-req-list')
                        // }
                        console.log(jqXHR);
                        console.log(exception);

                    }
                });
        },


}
}
</script>



// WEBPACK FOOTER //
// src/components/ETK/ETKList.vue